import { OauthBody } from '@integration-frontends/common/temporal-api';

export const OAUTH_SERVICE_TOKEN = 'OAUTH_REPO';

export interface IOauthService {
  signInOauth: (clientId, oauthBody: OauthBody) => Promise<any>;
  getHostUrl: () => string;
  refreshBrandfolderOauthToken: (refreshToken: string) => Promise<any>;
}
